import React, { useEffect, useState } from 'react';
import API from '../services/api';

const Leagues = () => {
  const [domestic, setDomestic] = useState([]);
  const [champions, setChampions] = useState([]);
  const [europa, setEuropa] = useState([]);
  const [loading, setLoading] = useState(true);
  const [continent, setContinent] = useState('Europe');

  useEffect(() => {
    const fetchAll = async () => {
      try {
        const [domRes, champRes, eurRes] = await Promise.all([
          API.get(`/league/standings/domestic?continent=${continent}`),
          API.get('/league/standings/champions'),
          API.get('/league/standings/europa'),
        ]);
        setDomestic(domRes.data);
        setChampions(champRes.data);
        setEuropa(eurRes.data);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchAll();
  }, [continent]);

  if (loading) return <div className="text-white">Loading...</div>;

  return (
    <div>
      <h1 className="text-2xl font-bold text-white mb-6">Leagues</h1>
      <div className="mb-4">
        <label className="text-white mr-2">Continent:</label>
        <select value={continent} onChange={(e) => setContinent(e.target.value)} className="bg-gray-800 text-white p-2 rounded">
          <option>Europe</option><option>Asia</option><option>Africa</option><option>Americas</option>
        </select>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <LeagueTable title="Domestic League" data={domestic} />
        <LeagueTable title="Champions League" data={champions} />
        <LeagueTable title="Europa League" data={europa} />
      </div>
    </div>
  );
};

const LeagueTable = ({ title, data }) => (
  <div className="bg-gray-800 rounded-lg p-4">
    <h2 className="text-xl font-bold text-yellow-400 mb-3">{title}</h2>
    <div className="overflow-x-auto">
      <table className="min-w-full text-sm">
        <thead className="text-gray-400 border-b border-gray-700">
          <tr><th className="p-2">Rank</th><th>Player</th><th>Pts</th><th>W-D-L</th></tr>
        </thead>
        <tbody>
          {data.slice(0, 10).map((row, idx) => (
            <tr key={idx} className="border-b border-gray-700 text-white">
              <td className="p-2">{idx+1}</td>
              <td>{row.username}</td>
              <td>{row.points}</td>
              <td>{row.wins}-{row.draws}-{row.losses}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
);

export default Leagues;